// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"281":"739318da","404":"3da3e838","718":"09ca7c0a"}[chunkId] + ".css";
};